var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FacialRecognitionError50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4114_494)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4114_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.603 0H0V43.7H45.603V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4114_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.237549 26.6416H45.3656V43.4124H0.237549V26.6416Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 41.0168H2.61279V32.6313H4.98795V38.6209H10.9258V41.0168ZM42.9904 41.0168H34.6774V38.6209H40.6153V32.6313H42.9904V41.0168Z",
    fill: "#00B8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9904 8.67301H40.6153V2.68343H34.6774V0.287598H42.9904V8.67301ZM4.98795 8.67301H2.61279V0.287598H10.9258V2.68343H4.98795V8.67301Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.865 24.2459C35.865 25.5636 34.7962 26.6418 33.4898 26.6418C32.1835 26.6418 31.1147 25.5636 31.1147 24.2459C31.1147 22.9282 32.1835 21.8501 33.4898 21.8501C34.7962 21.8501 35.865 22.9282 35.865 24.2459ZM14.4886 24.2459C14.4886 25.5636 13.4198 26.6418 12.1134 26.6418C10.8071 26.6418 9.73828 25.5636 9.73828 24.2459C9.73828 22.9282 10.8071 21.8501 12.1134 21.8501C13.4198 21.8501 14.4886 22.9282 14.4886 24.2459Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4897 17.0583C33.4897 7.95413 12.1133 11.0687 12.1133 17.0583V25.4437C12.1133 31.4333 16.8636 36.225 22.8015 36.225C28.7394 36.225 33.4897 31.4333 33.4897 25.4437V17.0583Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8016 6.2771C15.5574 6.2771 10.9258 12.1469 10.9258 19.4542V22.2094L13.301 24.2458V18.2563L27.5519 13.4646L32.3022 18.2563V24.2458L34.6774 22.2094V19.4542C34.6774 14.6625 33.4898 9.87085 27.5519 8.67293L26.3643 6.2771H22.8016Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3644 24.2458C26.3644 24.9645 26.8394 25.4437 27.552 25.4437C28.2645 25.4437 28.7396 24.9645 28.7396 24.2458C28.7396 23.527 28.2645 23.0479 27.552 23.0479C26.8394 23.0479 26.3644 23.527 26.3644 24.2458ZM16.8638 24.2458C16.8638 24.9645 17.3388 25.4437 18.0514 25.4437C18.7639 25.4437 19.2389 24.9645 19.2389 24.2458C19.2389 23.527 18.7639 23.0479 18.0514 23.0479C17.3388 23.0479 16.8638 23.527 16.8638 24.2458Z",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2322 26.6416C12.8259 32.0322 17.3387 36.2249 22.8016 36.2249C28.2645 36.2249 32.7773 32.0322 33.371 26.6416H12.2322Z",
    fill: "#00E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.237549 26.6416H45.3656V29.0374H0.237549V26.6416Z",
    fill: "#18FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4114_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8025 45.6908C49.8025 47.9622 47.9621 49.8026 45.6907 49.8026H24.3091C22.0377 49.8026 20.1973 47.9622 20.1973 45.6908V24.3092C20.1973 22.0378 22.0377 20.1974 24.3091 20.1974H45.6907C47.9621 20.1974 49.8025 22.0378 49.8025 24.3092V45.6908Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1018 43.2239L26.7758 40.8978L40.7566 26.9176L43.0825 29.2436L29.1018 43.2239Z",
    fill: "#FFEBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2439 40.7103L40.9179 43.0364L26.8622 28.9811L29.1882 26.6551L43.2439 40.7103Z",
    fill: "#FFEBEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4114_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4114_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FacialRecognitionError50);
export default __webpack_public_path__ + "static/media/icons8-facial-recognition-error-50.906a5f44aa005df68b8cce1b492e4cf0.svg";
export { ForwardRef as ReactComponent };